<div class="button-container">
	<button class="btn btn-sm cv-btn-blue" (click)="onAddCIJobType()">
		<i class="fas fa-plus"></i>
		Add CI Product
	</button>
</div>

<div class="datatable-content">
	<cv-input
		[value]="searchText"
		[type]="'text'"
		[name]="'Searchby'"
		[maxlength]="100"
		[placeholder]="'Search'"
		(controlKeyup)="onSearchTextChange($event)"
	></cv-input>
	<ag-grid-angular #grid class="ag-theme-balham configurable-grid"
									 [style.height.px]="gridHeight"
									 (gridReady)="onInitializeGrid($event)"
									 (gridSizeChanged)="resizeToFitColumns()"
									 [pagination]="true"
									 [animateRows]="true"
									 [suppressPaginationPanel]="true"
									 [gridOptions]="gridOptions"
									 [domLayout]="'normal'"
									 [rowData]="gridData">
	</ag-grid-angular>
</div>
